import { createCategoryMenuController } from '../../external/category-menu-widget/controller';

export default createCategoryMenuController;
